/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState } from "react";
import { track } from "jiffy-analytics";
import { remoteImageStaticUrl } from "common/utils/remote-image";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { useDtfStore } from "../store";
import { BACKGROUND_TYPES } from "./constants";
import "./BackgroundToggle.scss";

const BUTTON_CLASSES = {
  ACTIVE: "bg-black text-white hover:bg-black",
  INACTIVE: "bg-transparent hover:bg-gray-100"
};

const ANALYTICS_MODE_MAP = {
  [BACKGROUND_TYPES.GREEN]: "green screen",
  [BACKGROUND_TYPES.CHECKERED]: "chessboard"
};

function BackgroundToggle({
  modelValue = "checkered",
  onLearnMore = null,
  forceShow = false,
  onUpdateModelValue,
  className: restClassName,
  ...otherProps
}: any) {
  const store = useDtfStore();
  const [showTooltip, setShowTooltip] = useState(false);

  function transparencyGifUrl() {
    return remoteImageStaticUrl("gen/pdp/jiffy-transparancy-anim.gif", {
      auto: "format"
    });
  }

  function isStandardDTFProduct() {
    // @ts-expect-error TS(4111): Property 'isStandardDTFProduct' comes from an inde... Remove this comment to see the full error message
    return store.isStandardDTFProduct;
  }

  function shouldShowToggle() {
    // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
    return forceShow || store.catalogNumber === "DTF001";
  }

  function toggleTooltip() {
    setShowTooltip(!showTooltip);
  }

  function closeTooltip() {
    setShowTooltip(false);
  }

  function getButtonClasses(value: any) {
    return modelValue === value ? BUTTON_CLASSES.ACTIVE : BUTTON_CLASSES.INACTIVE;
  }

  function handleBackgroundChange(backgroundType: any) {
    track("image_preview_switcher_clicked", {
      page_type: "transfers_pdp",
      mode: ANALYTICS_MODE_MAP[backgroundType] || "chessboard",
      timestamp: Date.now()
    });
    onUpdateModelValue(backgroundType);
  }

  return (
    <>
      {shouldShowToggle() ? (
        <div {...otherProps} className={cn("scope-76e50200 relative", restClassName)}>
          <div className="scope-76e50200 top-[-18px] flex gap-px rounded-md border border-gray-300 bg-white p-0.5">
            <button
              className={cn(
                "scope-76e50200 flex cursor-pointer items-center justify-center rounded border-0 p-1.5 transition-all duration-150 ease-in-out",
                getButtonClasses(BACKGROUND_TYPES.CHECKERED)
              )}
              type="button"
              title="Checkered background"
              onClick={() => {
                handleBackgroundChange(BACKGROUND_TYPES.CHECKERED);
              }}
              data-testid="flex"
            >
              <svg
                className={cn(
                  "scope-76e50200 h-4 w-4",
                  modelValue === BACKGROUND_TYPES.CHECKERED && "text-white"
                )}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                data-testid="h-4"
              >
                <rect className="scope-76e50200" width="18" height="18" x="3" y="3" rx="2" />
                <path className="scope-76e50200" d="M3 9h18" />
                <path className="scope-76e50200" d="M3 15h18" />
                <path className="scope-76e50200" d="M9 3v18" />
                <path className="scope-76e50200" d="M15 3v18" />
              </svg>
            </button>
            <button
              className={cn(
                "scope-76e50200 flex cursor-pointer items-center justify-center rounded border-0 p-1.5 transition-all duration-150 ease-in-out",
                getButtonClasses(BACKGROUND_TYPES.GREEN)
              )}
              type="button"
              title="Green screen background"
              onClick={() => {
                handleBackgroundChange(BACKGROUND_TYPES.GREEN);
              }}
              data-testid="flex-1"
            >
              <svg
                className={cn(
                  "scope-76e50200 h-4 w-4",
                  modelValue === BACKGROUND_TYPES.GREEN && "text-white"
                )}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                data-testid="h-4-1"
              >
                <rect className="scope-76e50200" width="18" height="18" x="3" y="3" rx="2" />
              </svg>
            </button>
            {isStandardDTFProduct() ? (
              <button
                className={cn(
                  "background-toggle__learn-more-icon scope-76e50200 flex cursor-pointer items-center justify-center rounded border-0 bg-transparent p-1.5 transition-all duration-150 ease-in-out hover:bg-gray-100",
                  showTooltip && "bg-gray-100"
                )}
                type="button"
                title="Learn more about backgrounds"
                onClick={toggleTooltip}
                data-testid="background-toggle-learn-more-icon"
              >
                <UseSvg
                  className="scope-76e50200 h-4 w-4 text-gray-700"
                  icon="question-circle"
                  data-testid="h-4-2"
                />
              </button>
            ) : null}
          </div>
          {showTooltip ? (
            <div className="background-toggle__tooltip scope-76e50200">
              <div className="background-toggle__tooltip-content scope-76e50200">
                <button
                  className="background-toggle__tooltip-close scope-76e50200"
                  type="button"
                  onClick={closeTooltip}
                  data-testid="background-toggle-tooltip-close"
                >
                  <UseSvg
                    className="scope-76e50200 h-4 w-4"
                    icon="modal-close"
                    data-testid="h-4-3"
                  />
                </button>
                <h3 className="background-toggle__tooltip-title scope-76e50200">
                  Transparency check
                </h3>
                <p className="background-toggle__tooltip-text scope-76e50200">
                  {" "}
                  Toggle backgrounds to check transparency and edges. The checkered pattern reveals
                  any see-through areas, while solid green shows edge quality.{" "}
                </p>
                <img
                  className="background-toggle__tooltip-image scope-76e50200"
                  src={transparencyGifUrl()}
                  alt="Transparency check example"
                />
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  );
}

export default BackgroundToggle;
